<template>
  <v-layout pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10 md9 lg9 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Create Driver</h2>
          </v-flex>
          <v-flex xs12 pl-1>
            <h3>User</h3>
          </v-flex>
          <ExistingUser
            :errors="errors.user"
            @selectedUser="handleSelectedUser"
            @useExistingUserToggled="useExistingUserToggled"
            :useExistingUser="user.use_existing"
          />
          <v-flex xs12 md12>
            <UserForm
              ref="userForm"
              :disabled="user.use_existing"
              :user="user"
              :errors="errors.user"
              :editingUser="user.use_existing"
              @validityChange="updateFormValidity('user', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Driver</h3>
          </v-flex>
          <v-flex xs12 md12>
            <DriverForm
              ref="driverForm"
              :driver="driver"
              :driver_details="driver_details"
              :errors="driverErrors"
              @imageInput="handleImageInput"
              @documentInput="handleDocumentInput"
              @validityChange="updateFormValidity('driver', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Taxi</h3>
          </v-flex>
          <ExistingTaxi
            :errors="errors.taxi"
            @selectedTaxi="handleSelectedTaxi"
            @useExistingTaxiToggled="useExistingTaxiToggled"
          />
          <v-flex xs12 md12>
            <TaxiForm
              ref="taxiForm"
              :disabled="taxi.use_existing"
              :taxi="taxi"
              :errors="errors.taxi"
              :rideTypes="rideTypes"
              :councils="councils"
              @validityChange="updateFormValidity('taxi', $event)"
            />
          </v-flex>
          <v-flex xs12 md12>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Submit</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/driver/UserForm.vue";
import DriverForm from "@/components/driver/DriverForm.vue";
import TaxiForm from "@/components/driver/TaxiForm.vue";
import ExistingUser from "@/components/driver/ExistingUser.vue";
import ExistingTaxi from "@/components/driver/ExistingTaxi.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "create_driver",
  components: {
    SimpleCard,
    UserForm,
    DriverForm,
    TaxiForm,
    ExistingUser,
    ExistingTaxi,
  },
  data: function () {
    return {
      user: {
        use_existing: true,
        name: "",
        email: "",
        contact_number: "",
        password: "",
        accounting_reference_number: "",
      },
      driver: {
        callsign: "",
        driving_license_number: "",
        hackney_number: "",
        private_hire_number: "",
        driving_license_expiry: "",
        hackney_expiry: "",
        private_hire_expiry: "",
        fee_percentage: "0",
        picture: {},
        documents: [],
      },
      driver_details: {
        address_line_1: "",
        address_line_2: "",
        town: "",
        county: "",
        postcode: "",
        home_phone: "",
        b_tech: false,
        wheelchair_cert: false,
        nvq: false,
        adt: false,
      },
      taxi: {
        use_existing: false,
        registration_number: "",
        plate_number: "",
        make: "",
        model: "",
        colour: "",
        num_seats: 0,
        type: "",
        disabled_access: false,
        premium_vehicle: false,
        pets_allowed: false,
        wide: false,
        hackney_carriage: false,
        mot_valid_until: "",
        insurance_certificate_number: "",
        insurance_valid_until: "",
        compliance_certificate_expiry: "",
        road_tax_valid_until: "",
        council: "",
        ride_type_id: 0,
      },
      rideTypes: [],
      councils: [],
      errors: {},
      userFormValid: false,
      taxiFormValid: false,
      driverFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      driverApplication: null,
    };
  },
  mounted: function () {
    this.getTaxiInformation();

    var vm = this;

    console.log(this.$route.query.driverApplicationUserId);

    if (this.$route.query.driverApplicationUserId != null) {
      var applicantID = this.$route.query.driverApplicationUserId;
      this.getDriverApplication(applicantID);
    } else {
      this.user.use_existing = false;
    }
  },
  methods: {
    formatDate(date) {
      var date = moment(date).format("YYYY-MM-DD");

      if (date == "Invalid Date") {
        return "";
      }
    },
    populateFormFromApplication() {
      var da = this.driverApplication;
      var dd = da.driverSignupDetails;
      var ti = da.taxiSignupInformation;
      var u = da.user;

      //       user: {
      //   use_existing: false,
      //   name: "",
      //   email: "",
      //   contact_number: "",
      //   password: "",
      //   accounting_reference_number: ""
      // },

      this.user.id = u.id;
      this.user.name = u.name;
      this.user.email = u.email;
      this.user.contact_number = u.contactNumber;

      console.log(this.user);

      this.driver.driving_license_number = dd.licenceNumber;
      this.driver.hackney_number = dd.hackneyNumber;
      this.driver.private_hire_number = dd.hireNumber;
      this.driver.driving_license_expiry = this.formatDate(
        dd.licenceRenewalDate
      );
      this.driver.hackney_expiry = this.formatDate(dd.hackneyNumberRenewalDate);
      this.driver.private_hire_expiry = this.formatDate(
        dd.hireNumberRenewalDate
      );

      this.driver_details.address_line_1 = dd.address1;
      this.driver_details.address_line_2 = dd.address2;
      this.driver_details.town = dd.town;
      this.driver_details.county = dd.county;
      this.driver_details.postcode = dd.postcode;
      this.driver_details.home_phone = dd.homeNumber;

      this.driver_details.b_tech = dd.btech;
      this.driver_details.wheelchair_cert = dd.wheelChairCertificate;
      this.driver_details.nvq = dd.nvq;
      this.driver_details.adt = dd.adt;

      this.taxi.registration_number = ti.registrationNumber;
      this.taxi.plate_number = ti.plateNumber;
      this.taxi.make = ti.make;
      this.taxi.model = ti.model;
      this.taxi.colour = ti.colour;
      this.taxi.num_seats = ti.numSeats;
      this.taxi.disabled_access = ti.disabledAccess;
      this.taxi.premium_vehicle = ti.premiumVehicle;
      this.taxi.pets_allowed = ti.petsAllowed;
      this.taxi.wide = ti.wide;
      this.taxi.hackney_carriage = ti.wide;
      this.taxi.insurance_certificate_number = ti.insuranceCertificateNumber;
      this.taxi.mot_valid_until = this.formatDate(ti.motValidUntil);
      this.taxi.insurance_valid_until = this.formatDate(ti.insuranceValidUntil);
      this.taxi.compliance_certificate_expiry = this.formatDate(
        ti.complianceCertificateExpiry
      );
      this.taxi.road_tax_valid_until = this.formatDate(ti.roadTaxValidUntil);
      this.taxi.council = ti.council;
      this.taxi.type = ti.type;
    },
    getDriverApplication: async function (applicantID) {
      this.loading = true;

      let self = this;

      try {
        var url = `${this.$store.state.apiUrl}/driver_signup/${applicantID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverApplication = response.data;
        this.populateFormFromApplication();

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver application " + error);
      }
    },
    getTaxiInformation: async function () {
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    submit: async function () {
      if (this.userFormValid && this.taxiFormValid && this.driverFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/driver/create`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: this.driver,
            driver_details: this.driver_details,
            taxi: this.taxi,
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding driver, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding driver: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const driverID = response.data.driver.id;
              self.$router.push("../driver/view/" + driverID);
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.driverForm.validateForm();
        this.$refs.taxiForm.validateForm();
      }
    },
    handleImageInput: function (file) {
      this.driver.picture = file;
    },
    handleDocumentInput: function (files) {
      this.driver.documents = files;
    },
    handleSelectedUser: function (existingUser) {
      console.log("Selected User");

      this.user.id = existingUser.id;
      this.user.name = existingUser.name;
      this.user.email = existingUser.email;
      this.user.contact_number = existingUser.contact_number;
    },
    useExistingUserToggled: function (useExisting) {
      this.user.use_existing = useExisting;
    },
    handleSelectedTaxi: function (existingTaxi) {
      this.taxi.registration_number = existingTaxi.registration_number;
      this.taxi.plate_number = existingTaxi.plate_number;
      this.taxi.make = existingTaxi.make;
      this.taxi.model = existingTaxi.model;
      this.taxi.colour = existingTaxi.colour;
      this.taxi.council = existingTaxi.council;
      this.taxi.num_seats = existingTaxi.num_seats;
      this.taxi.type = existingTaxi.type;
      this.taxi.disabled_access = existingTaxi.disabled_access;
      this.taxi.premium_vehicle = existingTaxi.premium_vehicle;
      this.taxi.pets_allowed = existingTaxi.pets_allowed;
      this.taxi.wide = existingTaxi.wide;
      this.taxi.hackney_carriage = existingTaxi.hackney_carriage;
      this.taxi.mot_valid_until = existingTaxi.mot_valid_until;
      this.taxi.insurance_certificate_number =
        existingTaxi.insurance_certificate_number;
      this.taxi.insurance_valid_until = existingTaxi.insurance_valid_until;
      this.taxi.compliance_certificate_expiry =
        existingTaxi.compliance_certificate_expiry;
      this.taxi.road_tax_valid_until = existingTaxi.road_tax_valid_until;
      this.taxi.council = existingTaxi.council;
      this.taxi.ride_type_id = existingTaxi.ride_type_id;
    },
    useExistingTaxiToggled: function (useExisting) {
      this.taxi.use_existing = useExisting;
    },
    updateFormValidity: function (form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "driver":
          this.driverFormValid = value;
          break;
        case "taxi":
          this.taxiFormValid = value;
          break;
      }
    },
  },
  computed: {
    driverErrors: function () {
      return {
        ...this.errors.driver,
        ...this.errors.driver_details,
      };
    },
  },
};
</script>